module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-1a3b2d3067b21b9c1fe0a269ecda406b.webp";